<template lang="html">
  <div class="contacts">
    <h1 v-text="$ml.get('contacts.title')"/>
    <b-row>
      <b-col md="8" offset-md="2" sm="10" offset-sm="1" cols="12" lg="4" offset-lg="4">
        <GmapMap ref="mapRef"
          :center="markerpos"
          :zoom="15"
          style="width: 100%; height: 300px">
          <GmapMarker
            :position="markerpos"
            :clickable="true"></GMapMarker>
        </GmapMap>
      </b-col>
    </b-row>
    <b-row class="mt-4">
      <b-col md="8" offset-md="2" sm="10" offset-sm="1" cols="12" lg="4" offset-lg="4">
        <p class="company-info" v-html="$ml.get('contacts.company_info')"/>
      </b-col>
    </b-row>
    <h3 v-text="$ml.get('contacts.fill_title')"/>
    <b-row class="mt-4">
      <b-col md="8" offset-md="2" sm="10" offset-sm="1" cols="12" lg="4" offset-lg="4">
        <b-row>
          <b-col md="12">
            <b-form-group horizontal :label="$ml.get('contacts.company')" label-for="input-societa">
              <b-form-input id="input-societa" type="text" v-model="dati.societa" :state="dati.societa"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group horizontal :label="$ml.get('contacts.firstname')" label-for="input-nome">
              <b-form-input id="input-nome" type="text" v-model="dati.nome"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group horizontal :label="$ml.get('contacts.lastname')" label-for="input-cognome">
              <b-form-input id="input-cognome" type="text" v-model="dati.cognome"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group horizontal :label="$ml.get('contacts.email')" label-for="input-email">
              <b-form-input id="input-email" type="email" v-model="dati.email" :state="validEmail"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group horizontal :label="$ml.get('contacts.telephone')" label-for="input-telefono">
              <b-form-input id="input-teelfono" type="text" v-model="dati.telefono"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group horizontal :label="$ml.get('contacts.city')" label-for="input-citta">
              <b-form-input id="input-citta" type="text" v-model="dati.citta"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group horizontal :label="$ml.get('contacts.message')" label-for="text-messaggio">
              <b-form-textarea
                id="text-messaggio"
                v-model="dati.messaggio"
                rows="3"
                max-rows="6"></b-form-textarea>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-form-group horizontal :label="$ml.get('contacts.how')" label-for="select-come">
              <b-form-select id="select-come" v-model="dati.come" :options="$ml.get('contacts.how_options')"></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row v-if="showOtherInput">
          <b-col md="12">
            <b-form-group horizontal :label="$ml.get('contacts.how_answer')" label-for="input-altro">
              <b-form-input
                id="input-altro"
                type="text"
                v-model="dati.altro"
                :state="otherState"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <p class="privacy-text" v-text="$ml.get('contacts.privacy_info')"/>
            <b-form-group horizontal :label="$ml.get('contacts.privacy_agree')" label-for="check-accetto">
              <b-form-checkbox id="check-accetto" v-model="dati.accetto"></b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-button
              id="sendBtn"
              @click="sendRequest"
              style="text-align:center;"
              :disabled="alert.loading">
              {{ $ml.get('contacts.submit') }}
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-alert :show="alert.showing" :dismissible="!alert.loading" :variant="alert.variant">
              <i class="fas fa-spinner fa-spin" v-if="alert.loading" style="color:#999;margin-right:5px"></i>
              {{ alert.message }}
            </b-alert>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-button v-show="showGoTop" id="goTopBtn" @click="goTop()">Top</b-button>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dati: {
        societa: null,
        nome: null,
        cognome: null,
        email: null,
        telefono: null,
        citta: null,
        messaggio: null,
        come: 'motore di ricerca',
        altro: null,
        accetto: false
      },
      alert: {
        loading: false,
        variant: 'primary',
        showing: false,
        message: ''
      },
      hows: [
        'motore di ricerca',
        'banner',
        'link su altro sito',
        'casualmente',
        '(altro)'
      ],
      markerpos: {
        lat: 45.529107,
        lng: 9.074632
      },
      showGoTop: false
    }
  },
  computed: {
    showOtherInput: function () {
      return this.dati.come && this.dati.come === '(altro)'
    },
    otherState: function () {
      if (!this.dati.come || this.dati.come !== '(altro)') {
        return true
      }
      return this.dati.altro && this.dati.altro.length > 0
    },
    validEmail: function () {
      if (!this.dati.email) {
        return false
      }
      const regex = /^\S+@\S+$/
      const e = regex.exec(this.dati.email)
      return e && e[0]
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    alertError (msg) {
      this.alert.loading = false
      this.alert.message = msg
      this.alert.variant = 'danger'
      this.alert.showing = true
      return false
    },
    checkData () {
      if (!this.dati.nome || this.dati.nome.length === 0) {
        return this.alertError('Il campo Nome deve essere compilato')
      }
      if (!this.dati.cognome || this.dati.cognome.length === 0) {
        return this.alertError('Il campo Cognome deve essere compilato')
      }
      if (!this.dati.email || !this.validEmail) {
        return this.alertError('Il campo E-mail deve essere compilato')
      }
      if (!this.dati.messaggio || this.dati.messaggio.length === 0) {
        return this.alertError('Il campo Messaggio deve essere compilato')
      }
      return true
    },
    sendAlert (what) {
      this.alert.loading = false
      this.alert.showing = false
      switch (what) {
        case 0: // loading
          this.alert.message = 'Invio richiesta di contatto...'
          this.alert.variant = 'info'
          this.alert.loading = true
          break
        case 1: // success
          this.alert.message = 'Richiesta di contatto inviata'
          this.alert.variant = 'success'
          break
        case 2:
          this.alert.message = 'Non è stato possibile inviare la richiesta'
          this.alert.variant = 'danger'
          break
      }
      this.alert.showing = true
    },
    sendRequest () {
      if (!this.alert.loading && this.checkData()) {
        this.sendAlert(0)
        this.$http.post('http://piattaforma.opentracking.it/api/data', this.dati).then((response) => {
          if (response.status === 200) {
            this.sendAlert(1)
          } else {
            this.sendAlert(2)
          }
        }).catch(error => {
          console.log(JSON.stringify(error))
          this.sendAlert(2)
        })
      }
    },
    handleScroll (event) {
      this.showGoTop = document.body.scrollTop > 400 || document.documentElement.scrollTop > 400
    },
    goTop () {
      window.scroll({top: 0, behavior: 'smooth'})
    }
  }
}
</script>

<style lang="css" scoped>
.privacy-text {
  text-align: left;
}

.company-info {
  text-align: left;
  color: #999;
  font-size: 0.8rem;
}

#sendBtn {
  background-color: #E0161A;
  color: #FDFDFD;
  border: none;
}

#sendBtn:hover {
  background-color: #444;
}

</style>



// WEBPACK FOOTER //
// src/components/Contacts.vue